<template>
  <div>
    <bread-crumb
      :routeName="'Solutions'"
      :subRoute="solution_name"
    ></bread-crumb>
    <loading v-if="isLoading" :isLoading="isLoading"></loading>
    <hero :backgroundImage="slide_image" :content="slide_label"> </hero>
    <div class="container">
      <section class="has-primary-background section">
        <p
          class="subtitle is-5 is-white content"
          v-html="solution_description"
        ></p>
        <div class="columns is-multiline">
          <!-- <div class="column is-6" v-for="point in bullet_points">
                        <p class="m-b-50 is-white title is-4" >
                            {{point.value}}
                        </p>
                    </div> -->
          <div class="column is-6" v-if="case_study">
            <a
              class="m-b-50 is-red title is-4 is-hoverable"
              :href="`https://${this.baseURL()}/${case_study_pdf}`"
              download
            >
              <icon name="chevron-right"></icon> Download case study
            </a>
          </div>
        </div>
      </section>
    </div>
    <div class="columns is-gapless">
      <div
        class="column"
        :class="{
          'm-r-10': index < 2 && $mq.resize && $mq.above($mv.tablet),
          'm-b-10': $mq.resize && $mq.below($mv.tablet),
        }"
        v-for="(solution, index) in related"
      >
        <card
          :to="`solutions/${solution.solution_name}`"
          :red="true"
          :background="`https://${baseURL()}/${solution.slide_image.path}`"
          :subtitle="solution.slide_label"
          :title="solution.solution_name"
          height="40vh"
        ></card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide_image: "#",
      slide_label: " ",
      solutions: " ",
      solution_description: " ",
      case_study_pdf: " ",
      case_study: null,
      isLoading: false,
      loading: 0,
      loaded: 0,
      related: [],
      solution_name: " ",
    };
  },
  watch: {
    $route: function () {
      this.fetchData();
    },
  },
  mounted() {
    // subscribe to loading event to know how many images are loading
    this.$on("loading", () => {
      this.isLoading = true;
      this.loading++;
    });

    // detect when loading is finished
    this.$on("loaded", () => {
      this.loaded++;
      // working dynamically regardless of how many images are on page!
      if (this.loaded === this.loading) this.isLoading = false;
    });
  },
  methods: {
    fetchData() {
      // match the current parameter and get the matching capability
      this.axios
        .get(
          `https://${this.baseURL()}/api/collections/get/solutiona?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[solution_name]=${
            this.$route.params.slug
          }`
        )
        .then((data) => {
          if (data.data.entries.length === 0) {
            // display error component
            alert("error!");
            this.isLoading = false;
          }
          // localStorage.setItem('about', JSON.stringify(data.data));
          this.slide_image = `https://${this.baseURL()}${
            data.data.entries[0]["slide_image"]["path"]
          }`;
          this.slide_label = data.data.entries[0]["slide_label"];
          this.solution_description =
            data.data.entries[0]["solution_description"];
          this.case_study_pdf = data.data.entries[0]["case_study_pdf"];
          this.case_study = data.data.entries[0]["case_study"];
          this.solution_name = data.data.entries[0]["solution_name"];
        });
      // loop over all solutions BUT the one in the slug
      this.axios
        .get(
          `https://${this.baseURL()}/api/collections/get/solutiona?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[solution_name][$not]=${
            this.$route.params.slug
          }&fields[slide_image]=1&fields[slide_label]=1&fields[solution_name]=1&limit=3`
        )
        .then((data) => {
          console.log(data.data);
          this.related = data.data.entries;
        });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";

.content /deep/ strong,
h1,
h2 {
  color: $red !important;
  font-size: 1.7rem;
}
.content /deep/ * {
  @media (max-width: 770px) {
    padding: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// solutions.vue?3facc8a3